import React from "react";

const HcHeadline = ({ headline }) => {
  return (
    <div className="wp-block-kehittamo-block-hc-headline wp-block-kehittamo-block-hc">
      <h2 className="m-0 p-0 text-xl font-bold xl:text-left xl:text-4xl">
        {headline}
      </h2>
    </div>
  );
};

export default HcHeadline;
